import localforage from 'localforage'

class CacheDB {
  constructor (config) {
    this.config = config
    this.db = localforage.createInstance({
      name: config.name,
      storeName: 'cache',
    })
  }

  get (key) {
    return this.db.getItem(key)
  }

  set (key, value) {
    return this.db.setItem(key, value)
  }

  remove (keys) {
    if (keys.constructor !== Array) {
      keys = [keys]
    }
    keys.forEach((key) => {
      this.db.removeItem(key)
    })
  }
}

export { CacheDB }
export default CacheDB



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-cache-box/db/cache-db.js